var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ArraySchema, MapSchema, Schema, type } from "@colyseus/schema";
export class PlayerSchema extends Schema {
    constructor() {
        super(...arguments);
        this.id = "";
        this.name = "";
        this.avatarId = "avatar1";
        this.x = 0;
        this.y = 0;
        this.facing = "down";
        this.emote = "";
        /**
         * Bumped on every emote. Two 🙏 in a row are the same string, so without a
         * counter the second one would not register as a change and would never
         * reach anybody else's screen.
         */
        this.emoteSeq = 0;
        /** "" while walking; pins the avatar when set. */
        this.pose = "";
        /** Seat being occupied, or "" when standing. */
        this.seatId = "";
        /** Epoch ms of the last raised voice in the Sing-Along Pavilion. */
        this.singingUntil = 0;
    }
}
__decorate([
    type("string")
], PlayerSchema.prototype, "id", void 0);
__decorate([
    type("string")
], PlayerSchema.prototype, "name", void 0);
__decorate([
    type("string")
], PlayerSchema.prototype, "avatarId", void 0);
__decorate([
    type("number")
], PlayerSchema.prototype, "x", void 0);
__decorate([
    type("number")
], PlayerSchema.prototype, "y", void 0);
__decorate([
    type("string")
], PlayerSchema.prototype, "facing", void 0);
__decorate([
    type("string")
], PlayerSchema.prototype, "emote", void 0);
__decorate([
    type("number")
], PlayerSchema.prototype, "emoteSeq", void 0);
__decorate([
    type("string")
], PlayerSchema.prototype, "pose", void 0);
__decorate([
    type("string")
], PlayerSchema.prototype, "seatId", void 0);
__decorate([
    type("number")
], PlayerSchema.prototype, "singingUntil", void 0);
export class FlowerSchema extends Schema {
    constructor() {
        super(...arguments);
        this.id = "";
        this.x = 0;
        this.y = 0;
        this.offeredAt = 0;
        this.byName = "";
        this.kind = 0;
    }
}
__decorate([
    type("string")
], FlowerSchema.prototype, "id", void 0);
__decorate([
    type("number")
], FlowerSchema.prototype, "x", void 0);
__decorate([
    type("number")
], FlowerSchema.prototype, "y", void 0);
__decorate([
    type("number")
], FlowerSchema.prototype, "offeredAt", void 0);
__decorate([
    type("string")
], FlowerSchema.prototype, "byName", void 0);
__decorate([
    type("number")
], FlowerSchema.prototype, "kind", void 0);
export class DiyaSchema extends Schema {
    constructor() {
        super(...arguments);
        this.id = "";
        this.x = 0;
        this.y = 0;
        /** Unix epoch ms, used for the oldest-fades-first cap. */
        this.litAt = 0;
        /** Who lit it. Shown on the diya, and it is why people come back. */
        this.byName = "";
    }
}
__decorate([
    type("string")
], DiyaSchema.prototype, "id", void 0);
__decorate([
    type("number")
], DiyaSchema.prototype, "x", void 0);
__decorate([
    type("number")
], DiyaSchema.prototype, "y", void 0);
__decorate([
    type("number")
], DiyaSchema.prototype, "litAt", void 0);
__decorate([
    type("string")
], DiyaSchema.prototype, "byName", void 0);
export class TributeSchema extends Schema {
    constructor() {
        super(...arguments);
        this.id = "";
        this.text = "";
        this.name = "";
        this.approvedAt = 0;
    }
}
__decorate([
    type("string")
], TributeSchema.prototype, "id", void 0);
__decorate([
    type("string")
], TributeSchema.prototype, "text", void 0);
__decorate([
    type("string")
], TributeSchema.prototype, "name", void 0);
__decorate([
    type("number")
], TributeSchema.prototype, "approvedAt", void 0);
export class ShowStateSchema extends Schema {
    constructor() {
        super(...arguments);
        this.phase = "preshow";
        /** True when a moderator has pinned the phase by hand. */
        this.held = false;
        this.startedAtEpoch = 0;
        this.videoTimestamp = 0;
        this.videoDurationSec = 0;
    }
}
__decorate([
    type("string")
], ShowStateSchema.prototype, "phase", void 0);
__decorate([
    type("boolean")
], ShowStateSchema.prototype, "held", void 0);
__decorate([
    type("number")
], ShowStateSchema.prototype, "startedAtEpoch", void 0);
__decorate([
    type("number")
], ShowStateSchema.prototype, "videoTimestamp", void 0);
__decorate([
    type("number")
], ShowStateSchema.prototype, "videoDurationSec", void 0);
export class ConcertRoomState extends Schema {
    constructor() {
        super(...arguments);
        this.players = new MapSchema();
        this.showState = new ShowStateSchema();
        /** Diyas lit in this room, oldest first. Capped; see MAX_DIYAS_PER_ROOM. */
        this.diyas = new ArraySchema();
        /** Approved tributes only. Nothing reaches this array unmoderated. */
        this.tributes = new ArraySchema();
        /** Flowers laid in this room, oldest first. Capped; see MAX_FLOWERS_PER_ROOM. */
        this.flowers = new ArraySchema();
        /** Diyas lit across every room tonight, not just this one. */
        this.globalDiyaCount = 0;
        /** Flowers offered across every room tonight. */
        this.globalFlowerCount = 0;
        /**
         * The Radio Garden is a shared broadcast, not a personal playlist: everyone
         * standing in the garden hears the same thing, which is the whole point of
         * listening together.
         */
        this.radioStation = "";
        /** How many people are singing right now, for the pavilion's chorus meter. */
        this.singingCount = 0;
    }
}
__decorate([
    type({ map: PlayerSchema })
], ConcertRoomState.prototype, "players", void 0);
__decorate([
    type(ShowStateSchema)
], ConcertRoomState.prototype, "showState", void 0);
__decorate([
    type([DiyaSchema])
], ConcertRoomState.prototype, "diyas", void 0);
__decorate([
    type([TributeSchema])
], ConcertRoomState.prototype, "tributes", void 0);
__decorate([
    type([FlowerSchema])
], ConcertRoomState.prototype, "flowers", void 0);
__decorate([
    type("number")
], ConcertRoomState.prototype, "globalDiyaCount", void 0);
__decorate([
    type("number")
], ConcertRoomState.prototype, "globalFlowerCount", void 0);
__decorate([
    type("string")
], ConcertRoomState.prototype, "radioStation", void 0);
__decorate([
    type("number")
], ConcertRoomState.prototype, "singingCount", void 0);
//# sourceMappingURL=schema.js.map